export const DECRYPTION_BLOCKED_CONTENT = "__DECRYPTION_BLOCKED__"

export const isDecryptionBlocked = (content: string | undefined | null) =>
  content === DECRYPTION_BLOCKED_CONTENT
